<template>
  <Card>
    <VisitorDashboard v-if="currentUser && currentUser.user_role === 'visitor'"></VisitorDashboard>
  </Card>

</template>
<script>
import MasterLayout from "../components/MasterLayout";
import ImagePicker from "@/components/ImagePicker";
import ImagePickerGallery from "@/components/ImagePickerGallery";
import {mapActions, mapGetters} from "vuex";
import Card from "@/components/forms/Card";
import VisitorDashboard from "@/components/dashboard/visitorDashboard";
export default {
  data()
  {
    return{

    }
  },
  computed : {
    ...mapGetters('auth',{
      currentUser : 'getUserInfo'
    })
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('داشبورد');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  },
  components: {VisitorDashboard, Card, ImagePickerGallery, ImagePicker, MasterLayout}
}
</script>